import { useState } from 'react';
import { FilePlus, X, Check } from 'lucide-react';
import { groupsAPI } from '../api';
import './CreateFileModal.css';

function CreateFileModal({ onClose, onCreate, groups, initialContent = '', initialName = '' }) {
  const [fileName, setFileName] = useState(initialName);
  const [content, setContent] = useState(initialContent);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [newGroupName, setNewGroupName] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');

  const groupList = Object.entries(groups || {});

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fileName.trim()) { setError('Введите имя файла'); return; }
    setIsCreating(true);
    setError('');
    try {
      let groupId = selectedGroup === '__new' ? null : (selectedGroup || null);
      if (selectedGroup === '__new') {
        if (!newGroupName.trim()) { setError('Введите название новой группы'); setIsCreating(false); return; }
        const id = newGroupName.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        if (!id) { setError('Некорректное название группы'); setIsCreating(false); return; }
        await groupsAPI.create(id, newGroupName.trim());
        groupId = id;
      }
      await onCreate(fileName.trim(), content, groupId);
    } catch (err) {
      setError(err.message || 'Ошибка создания файла');
      setIsCreating(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2><FilePlus size={16} /> {initialName ? 'Дублировать файл' : 'Создать файл'}</h2>
          <button onClick={onClose} className="modal-close"><X size={14} /></button>
        </div>

        {error && <div className="alert alert-error" style={{ margin: '0 20px 12px' }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="fileName">Имя файла</label>
              <input
                id="fileName"
                type="text"
                className="input"
                value={fileName}
                onChange={(e) => setFileName(e.target.value)}
                placeholder="Например: sub1 или sub1.json"
                autoFocus
                disabled={isCreating}
              />
              <span className="form-hint">Расширение .json будет добавлено автоматически</span>
            </div>

            <div className="form-group">
              <label htmlFor="fileGroup">Группа</label>
              <select
                id="fileGroup"
                className="input"
                value={selectedGroup}
                onChange={(e) => setSelectedGroup(e.target.value)}
                disabled={isCreating}
              >
                <option value="">— Без группы —</option>
                {groupList.map(([id, group]) => (
                  <option key={id} value={id}>{group.name}</option>
                ))}
                <option value="__new">+ Создать новую группу...</option>
              </select>
            </div>

            {selectedGroup === '__new' && (
              <div className="form-group">
                <label htmlFor="newGroupName">Название новой группы</label>
                <input
                  id="newGroupName"
                  type="text"
                  className="input"
                  value={newGroupName}
                  onChange={(e) => setNewGroupName(e.target.value)}
                  placeholder="Например: VIP"
                  disabled={isCreating}
                />
              </div>
            )}

            <div className="form-group">
              <label htmlFor="fileContent">Содержимое (необязательно)</label>
              <textarea
                id="fileContent"
                className="textarea"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="Вставьте VPN-ссылки, каждая на новой строке..."
                rows={5}
                disabled={isCreating}
                spellCheck={false}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" onClick={onClose} className="btn btn-secondary" disabled={isCreating}>
              Отмена
            </button>
            <button type="submit" className="btn btn-success" disabled={isCreating}>
              <Check size={14} /> {isCreating ? 'Создание...' : 'Создать файл'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateFileModal;
